module.exports = __webpack_public_path__ + "img/ic-error.223a10b7.png";